import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'

import { saveData } from './actions'

class RowDetails extends Component {
  constructor(props) {
    super(props)

    this.state = {
      popCount: '~',
      income_levels: [
        'No Answer',
        'Less than $25,000',
        '$25,000 and above',
        '$35,000 and above',
        '$50,000 and above',
        '$75,000 and above',
        '$100,000 and above',
        '$150,000 and above'
      ],
      education_levels: [
        'Everyone',
        'High School or above',
        'Some College or above',
        'Associate Degree or above',
        'Bachelor Degree or above',
        'Graduate Degree or above',
        'PHD / Post Doctoral'
      ]
    }
  }

  getDistribution(row) {
    let currentComponent = this
    // Get Population Count
    console.log(row)
    //alert(JSON.stringify(row))
    //alert('https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/1/agehigh/'+this.state.oldest+'/agelow/'+this.state.youngest+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/50/herprefans/0/clrhigh/5/clrlow/1')
    axios({
      method: 'get',
      url:
        'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/' +
        row.Oldest_Dating_Age +
        '/agelow/' +
        row.Youngest_Dating_Age +
        '/oarhigh/' +
        row.Oar_High +
        '/oarlow/' +
        row.Oar_Low +
        '/herprefage/' +
        row.Profile_Oldest_Dating_Age +
        '/herprefans/0/clrhigh/' +
        row.Color_High +
        '/clrlow/' +
        row.Color_Low +
        '/cust/' +
        this.props.customer_number
    }).then(function(response) {
      console.log(row.Search_Name + ': ' + response.data[0]['SearchCount'])
      currentComponent.setState({
        popCount: response.data[0]['SearchCount']
      })
    })
  }

  getFullDistribution(row) {
    let currentComponent = this
    // Get Population Count
    //alert('https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/1/agehigh/'+this.state.oldest+'/agelow/'+this.state.youngest+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/50/herprefans/0/clrhigh/5/clrlow/1')
    axios({
      method: 'get',
      url:
        'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/0/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/42/agelow/41/oarhigh/10/oarlow/1/herprefage/50/herprefans/0/clrhigh/5/clrlow/1/cust/' +
        this.props.customer_number
    }).then(function(response) {
      console.log(row.Search_Name + ': ' + response.data[0]['SearchCount'])
      currentComponent.setState({
        popCount: response.data[0]['SearchCount']
      })
    })
  }

  componentDidMount() {}

  onSelect(row) {
    this.props.saveData(
      row.Youngest_Dating_Age,
      row.Oldest_Dating_Age,
      row.Oar_Low,
      row.Oar_High,
      59
    )
    this.props.changeRoute(
      '/console/search/saved_searches/filters/' +
        row.id +
        '?name=' +
        row.Search_Name +
        '?count=' +
        this.state.popCount
    )
  }

  render() {
    const { classes, theme, location } = this.props
    const { row, data } = this.props

    if (this.props.row.Search_Name == 'All Candidates') {
      this.getFullDistribution(row)
    } else {
      this.getDistribution(row)
    }
    let education = 0
    let income = 0

    if (row.Education_Low) {
      education = row.Education_Low
    }

    if (row.Income_Low) {
      income = row.Income_Low
    }

    if (row.Search_Name == 'All Candidates') {
      return (
        <div className={classes.root}>
          <div>
            This saved search contains an unfiltered list of all the users in
            our database.
          </div>
          <br />
          <br />
          <Typography type="body2">Active Population Count:</Typography>
          <br />
          <div>Candidates: {this.state.popCount}</div>
          <Button
            onClick={() => this.onSelect(row)}
            className={classes.button}
            raised
            color="primary"
          >
            Select
          </Button>
        </div>
      )
    } else {
      console.log(row)

      return (
        <div className={classes.root}>
          <Typography type="body2">Filter Properties:</Typography>
          <br />
          <div>
            OAR: {row.Oar_Low} - {row.Oar_High}
          </div>
          <div>
            AGE: {row.Youngest_Dating_Age} - {row.Oldest_Dating_Age}
          </div>
          <div>Oldest Preferred Age: {row.Profile_Oldest_Dating_Age}</div>
          <div>Income: {this.state.income_levels[income]}</div>
          <div>Education: {this.state.education_levels[education]}</div>
          <br />
          <br />
          <Typography type="body2">Active Population Count:</Typography>
          <br />
          <div>Candidates: {this.state.popCount}</div>
          <Button
            onClick={() => this.onSelect(row)}
            className={classes.button}
            raised
            color="primary"
          >
            Select
          </Button>
          <div className={classes.emptySpace} />
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id
  }
}

function matchDispatchToProps(dispatch) {
  return {
    saveData: bindActionCreators(saveData, dispatch),
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, matchDispatchToProps)(RowDetails)
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/components/RowDetails/index.js